(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sections-cizz-alo-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.czalo').forEach(function (root) {
      var sid = root.dataset.sectionId;
      var dataEl = document.querySelector('[data-czalo-variants="' + sid + '"]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var optGroups = root.querySelectorAll('[data-czalo-option]');
      var priceEls = root.querySelectorAll('[data-czalo-price]');
      var idInput = root.querySelector('[data-czalo-variant-id]');
      var atc = root.querySelector('[data-czalo-atc]');
      var atcText = root.querySelector('[data-czalo-atc-text]');
      var form = root.querySelector('[data-czalo-form], form.czalo-form');
      var atcDefault = atcText ? atcText.textContent.trim() : 'Add to Bag';

      /* refresh cart count bubbles + notify theme */
      function refreshCartUI() {
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var count = cart.item_count;
            /* CIZARO header cart badge — create it if the cart started empty */
            document.querySelectorAll('.cz-header__cart-btn').forEach(function (cartBtn) {
              var badge = cartBtn.querySelector('.cz-header__badge');
              if (!badge) {
                badge = document.createElement('span');
                badge.className = 'cz-header__badge';
                cartBtn.appendChild(badge);
              }
              badge.textContent = count;
              badge.hidden = count < 1;
              badge.style.display = count < 1 ? 'none' : '';
            });
            /* generic fallbacks for other themes */
            document.querySelectorAll('[data-cart-count], .cart-count-bubble, .cart-bubble__text').forEach(function (el) {
              el.textContent = count;
            });
            document.dispatchEvent(new CustomEvent('cart:update', { detail: { cart: cart }, bubbles: true }));
          });
      }

      function addVariantToCart(variantId, onDone, onError) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            refreshCartUI();
            if (onDone) onDone();
          })
          .catch(function () {
            if (onError) onError();
          });
      }

      function selectedOptions() {
        var out = [];
        optGroups.forEach(function (g) {
          var sel = g.querySelector('.is-selected');
          out[parseInt(g.dataset.optionIndex, 10)] = sel ? sel.dataset.czaloValue : null;
        });
        return out;
      }

      function findVariant(opts) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) {
            return opts[i] === null || opts[i] === undefined || o === opts[i];
          });
        });
      }

      function refreshAvailability() {
        var opts = selectedOptions();
        optGroups.forEach(function (g) {
          var idx = parseInt(g.dataset.optionIndex, 10);
          g.querySelectorAll('[data-czalo-value]').forEach(function (btn) {
            var test = opts.slice();
            test[idx] = btn.dataset.czaloValue;
            var v = variants.find(function (vv) {
              return vv.options.every(function (o, i) {
                return test[i] === null || test[i] === undefined || o === test[i];
              });
            });
            btn.classList.toggle('is-unavailable', !(v && v.available));
          });
        });
      }

      function applyVariant() {
        var v = findVariant(selectedOptions());
        if (!v) return;
        if (idInput) {
          idInput.value = v.id;
          /* fire change so Find-in-Store (and other listeners) resync the SKU */
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        /* keep the gallery wishlist heart pointed at the current variant */
        var heart = root.querySelector('[data-czalo-wishheart]');
        if (heart) {
          heart.dataset.variant = v.id;
          heart.dataset.price = v.price;
        }
        priceEls.forEach(function (el) {
          el.innerHTML = v.price + (v.compare_at ? ' <s>' + v.compare_at + '</s>' : '');
        });
        if (atc) {
          atc.disabled = !v.available;
          if (atcText) atcText.textContent = v.available ? atcDefault : 'Sold Out';
        }
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url);
        } catch (e) {}
        refreshAvailability();
      }

      optGroups.forEach(function (g) {
        g.querySelectorAll('[data-czalo-value]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            g.querySelectorAll('.is-selected').forEach(function (b) {
              b.classList.remove('is-selected');
            });
            btn.classList.add('is-selected');
            applyVariant();
          });
        });
      });

      refreshAvailability();

      /* AJAX add to cart */
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (atc && atc.disabled) return;
          var fd = new FormData(form);
          if (atcText) atcText.textContent = 'Adding…';
          fetch('/cart/add.js', { method: 'POST', body: fd })
            .then(function (r) {
              if (!r.ok) throw new Error('add failed');
              return r.json();
            })
            .then(function () {
              if (atcText) atcText.textContent = 'Added ✓';
              setTimeout(function () {
                if (atcText) atcText.textContent = atcDefault;
              }, 2000);
              refreshCartUI();
            })
            .catch(function () {
              if (atcText) atcText.textContent = 'Error — try again';
              setTimeout(function () {
                if (atcText) atcText.textContent = atcDefault;
              }, 2500);
            });
        });
      }

      /* Shop the Look progress bar */
      var track = root.querySelector('[data-czalo-stl-track]');
      var bar = root.querySelector('[data-czalo-stl-bar]');
      if (track && bar) {
        var update = function () {
          var max = track.scrollWidth - track.clientWidth;
          var ratio = track.clientWidth / track.scrollWidth;
          bar.style.width = Math.max(ratio * 100, 12) + '%';
          var progress = max > 0 ? track.scrollLeft / max : 0;
          bar.style.transform = 'translateX(' + progress * (100 / Math.max(ratio, 0.12) - 100) + '%)';
        };
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      }

      /* ── Shop the Look quick add ── */
      var qaModal = root.querySelector('[data-czalo-qamodal]');
      var qaList = qaModal ? qaModal.querySelector('[data-czalo-qa-list]') : null;

      function qaClose() {
        if (qaModal) qaModal.hidden = true;
      }

      if (qaModal) {
        qaModal.querySelectorAll('[data-czalo-qa-close]').forEach(function (el) {
          el.addEventListener('click', qaClose);
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') qaClose();
        });
      }

      root.querySelectorAll('[data-czalo-qa]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var holder = btn.closest('.czalo-stl__imgwrap');
          var jsonEl = holder ? holder.querySelector('[data-czalo-stl-json]') : null;
          if (!jsonEl || !qaModal || !qaList) return;
          var data;
          try {
            data = JSON.parse(jsonEl.textContent);
          } catch (err) {
            return;
          }

          /* single default variant → add straight away, no modal */
          if (data.variants.length === 1 && data.variants[0].label === 'Default Title') {
            addVariantToCart(data.variants[0].id);
            return;
          }

          qaList.innerHTML = '';
          data.variants.forEach(function (v) {
            var row = document.createElement('button');
            row.type = 'button';
            row.className = 'czalo-qa-row' + (v.available ? '' : ' is-soldout');

            var label = document.createElement('span');
            label.textContent = v.label;
            row.appendChild(label);

            var note = document.createElement('span');
            note.className = 'czalo-qa-note';
            if (v.note) note.textContent = '- ' + v.note;
            row.appendChild(note);

            if (v.available) {
              row.addEventListener('click', function () {
                note.textContent = '- Adding…';
                addVariantToCart(
                  v.id,
                  function () {
                    note.textContent = '- Added ✓';
                    setTimeout(qaClose, 700);
                  },
                  function () {
                    note.textContent = '- Error, try again';
                  }
                );
              });
            } else {
              row.disabled = true;
            }
            qaList.appendChild(row);
          });

          qaModal.hidden = false;
        });
      });

      /* ── Order-by countdown blocks ── */
      root.querySelectorAll('[data-czalo-countdown]').forEach(function (el) {
        var cutoff = parseInt(el.dataset.cutoff, 10);
        var out = el.querySelector('[data-czalo-count]');
        if (isNaN(cutoff) || !out) return;
        function tick() {
          var now = new Date();
          var end = new Date(now);
          end.setHours(cutoff, 0, 0, 0);
          var diff = end - now;
          if (diff <= 0) {
            el.style.display = 'none';
            return;
          }
          var h = Math.floor(diff / 3600000);
          var m = Math.floor((diff % 3600000) / 60000);
          var s = Math.floor((diff % 60000) / 1000);
          out.textContent = (h > 0 ? h + 'h ' : '') + m + 'm ' + s + 's';
        }
        tick();
        setInterval(tick, 1000);
      });

      /* smooth-scroll for "Fit & Description" link → first accordion in this section */
      root.querySelectorAll('[data-czalo-scrollto]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var target = root.querySelector('.czalo-acc');
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            target.open = true;
          }
        });
      });

      /* ── Mobile sticky ATC bar ── */
      var stickyBar = root.querySelector('[data-czalo-stickybar]');
      var stickyBtn = root.querySelector('[data-czalo-sticky-atc]');
      var stickyText = root.querySelector('[data-czalo-sticky-atc-text]');
      if (stickyBar && stickyBtn && atc) {
        var buyBlock = root.querySelector('.czalo-block--buy');
        if ('IntersectionObserver' in window && buyBlock) {
          new IntersectionObserver(function (entries) {
            var entry = entries[0];
            var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            stickyBar.hidden = !passed;
          }, { threshold: 0 }).observe(buyBlock);
        } else {
          stickyBar.hidden = false;
        }
        var syncSticky = function () {
          stickyBtn.disabled = atc.disabled;
          if (stickyText && atcText) stickyText.textContent = atcText.textContent;
        };
        syncSticky();
        if ('MutationObserver' in window) {
          if (atcText) new MutationObserver(syncSticky).observe(atcText, { childList: true, characterData: true, subtree: true });
          new MutationObserver(syncSticky).observe(atc, { attributes: true, attributeFilter: ['disabled'] });
        }
        stickyBtn.addEventListener('click', function () {
          if (!form || stickyBtn.disabled) return;
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        });
      }
    });

    /* ── Trust-pill modals (delegated, works for every instance) ── */
    (function () {
      function closeAll() {
        document.querySelectorAll('.czalo-tp__modal').forEach(function (m) {
          m.setAttribute('aria-hidden', 'true');
        });
      }
      document.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-czalo-tp-open]');
        if (opener) {
          e.preventDefault();
          var m = document.getElementById(opener.getAttribute('data-czalo-tp-open'));
          if (m) {
            closeAll();
            m.setAttribute('aria-hidden', 'false');
          }
          return;
        }
        if (e.target.closest('[data-czalo-tp-close]')) {
          e.preventDefault();
          closeAll();
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeAll();
      });
    })();
  })();

  } catch(e) { console.error(e); }
})();
})();
